export interface EventHandler {
    receivedEvent: (event: string, data: any) => void;
}

/**
 * @param instant if the event should be triggered at once or after a timeout
 * @param buffer (only useful when instant=true) whether to buffer events (false if only the last event is relevant)
 */
export function createInstanceEventHandler<T extends EventHandler>(
    instant = false,
    buffer = false
) {
    let instances = {} as Record<number, T>;

    const registerInstance = (instance: T, id: number) => {
        instances[id] = instance;
        return () => delete instances[id];
    };

    let timeout = {} as any;
    const onEvent = (id: number, event: string, ...data: [any]) => {
        if (data.length <= 1) data = data[0];
        if (instant) {
            instances[id].receivedEvent(event, data);
        } else {
            if (!buffer) clearTimeout(timeout[event]);
            timeout[event] = setTimeout(() => instances[id]?.receivedEvent(event, data));
        }
    };

    return {
        onEvent,
        registerInstance,
    };
}
